/**
 *
 * 中信证券
 *
 */

import { getUrlParam } from '@/utils/api';
import { isBuild } from '@/utils/const';

const comein_channel = 'zhongxinzq';

export const isThirdParty = getUrlParam().comein_channel === comein_channel;

function Bridge() {
	this.title = '中信证券';

	this.comein_channel_pc = 'zxzq';

	this.comein_channel = comein_channel;

	this.instituteUser = {
		showEmail: true
	};

	this.authMethod = 1;

	// 以前部分接口需要传zid、后面改成传uc
	this.zid = isBuild ? 241 : 172;
	this.uc = isBuild ? 'ac3eafa9-75cb-4bf2-ba95-b18f1071288f' : 'ac3eafa9-75cb-4bf2-ba95-b18f1071288f';

	this.instituteLogin = {
		// emailLoginType: 1,
	};

	this.bindPhone = {
		loginWay: [0]
	};
}

// 获取分享配置
Bridge.prototype.getShareData = function () {
	return {
		title: '中信证券',
		desc: '中信证券研究部秉持“激情、创新、整合、卓越”的价值理念，以前沿技术的深度研究、行业趋势的前瞻预测和公司价值的准确把握为努力方向，旨在为国内外专业投资者提供决策建议和参考，同时也为政策制定者献计献策',
		link: location.href,
		img_url: 'https://resource.comein.cn/comein-files/img/default/zhongxinlogo.png'
	};
};

export default Bridge;
